import { render, staticRenderFns } from "./monthly-chart.vue?vue&type=template&id=8672354a"
import script from "./monthly-chart.vue?vue&type=script&lang=js"
export * from "./monthly-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports